export default __webpack_public_path__ + "static/media/code.523b7e5d.svg";